<template>
  <!-- 续保管理 -->
  <div class="renewManage main-container">
    <div class="content">
      <div class="search-box btn3" :class="{'close':!searchMore}">
        <div class="input-item select-two">
          <Select
            class="input-item-select"
            style="width: 110px"
            :transfer="true"
            v-model="searchParams.policyNoSelect"
          >
            <Option value="1" label="原保单号"></Option>
            <Option value="2" label="续保保单号"></Option>
          </Select>
          <Input v-model="searchParams.policyNumber" clearable placeholder="请输入"/>
        </div>

        <div class="input-item">
          <span class="label">机构</span>
          <selectTree type="1" v-model="searchParams.orgId" @change="getSelectNodes"></selectTree>
        </div>

        <div class="input-item">
          <span class="label">业务员</span>
          <Input
            v-model="searchParams.salesmanNameOrPhone"
            placeholder="请输入姓名或手机号"
            clearable
          />
        </div>

        <div class="input-item select-two">
          <Select
            class="input-item-select"
            style="width: 130px"
            :transfer="true"
            v-model="searchParams.multiple"
          >
            <Option value="1" label="原保单生效日"></Option>
            <Option value="2" label="最早续保日"></Option>
            <Option value="3" label="最晚续保日"></Option>
            <Option value="4" label="实际续保日"></Option>
          </Select>
          <DatePicker
            :clearable='true'
            :transfer="true"
            separator="至"
            type="daterange"
            v-model="searchParams.multipleDate"
            format="yyyy-MM-dd"
            placeholder="请选择时间"
          ></DatePicker>
        </div>

        <div class="input-item">
          <span class="label">原单到期日</span>
          <DatePicker
            :clearable='true'
            type="daterange"
            split-panels
            separator="至"
            :transfer="true"
            placement="bottom"
            v-model="searchParams.expireDate"
            format="yyyy-MM-dd"
            placeholder="选择日期"
          >
          </DatePicker>
        </div>

        <!-- <div class="input-item">
          <span class="label">保单来源</span>
          <Select clearable v-model="searchParams.source" filterable>
            <Option
              v-for="(item, index) in sourceList"
              :value="item"
              :key="index"
              >{{ item }}</Option
            >
          </Select>
        </div> -->

        <div class="input-item">
          <span class="label">保险公司</span>
          <Select clearable v-model="searchParams.companyCode" filterable>
            <Option
              :value="item.code"
              v-for="(item, index) in companyList"
              :key="index"
              >{{ item.name }}</Option
            >
          </Select>
        </div>

        <div class="input-item">
          <span class="label">投保人</span>
          <Input
            v-model="searchParams.holderNameOrPhone"
            placeholder="请输入姓名或手机号"
            clearable
          />
        </div>

        <div class="input-item">
          <span class="label">续保类型</span>
          <Select clearable v-model="searchParams.renewalSource">
            <Option value="1">原单续保</Option>              
            <Option value="3">重投（非续保）</Option>
            <Option value="2">新单</Option>
          </Select>
        </div>

        <div class="input-item">
          <span class="label">原产品名称/code</span>
          <Select v-model="searchParams.productCode" :transfer="true" filterable clearable>
            <Option v-for="(item, i) in productList" :key="i" :value="item.productCode">{{ item.productName }}({{item.productCode}})</Option>
          </Select>
        </div>
        <div class="input-item" v-if="$units.superviseShowVal() && $units.pointAction('renewalManage_01_10')">
          <span class="label">供应商类型</span>
          <RadioGroup v-model="searchParams.supplierType" @on-change="changeSupplierType">
            <Radio label="">全部</Radio>
            <Radio label="1">保司</Radio>
            <Radio label="2">通道</Radio>
          </RadioGroup>
        </div>
        <div class="input-item" v-if="searchParams.supplierType && $units.superviseShowVal() && $units.pointAction('renewalManage_01_10')">
          <span class="label">供应商</span>
          <Select v-model="searchParams.supplierIds" multiple :max-tag-count="4" clearable filterable>
            <Option :value="item.id" v-for="(item, index) in supplierList" :key="index">{{ item.name }}</Option>
          </Select>
        </div>

        <div class="input-item">
          <span class="label">跟进状态</span>
          <Select clearable v-model="searchParams.serviceState">
            <Option
              :value="item.value"
              v-for="(item, index) in serviceStateList"
              :key="index"
              >{{ item.label }}</Option
            >
          </Select>
        </div>

        <div class="input-item" v-if="searchParams.tab ==2">
          <span class="label">跟进类型</span>
          <Select clearable v-model="searchParams.payWaitType">
            <Option value="8">无法联系</Option>
            <Option value="9">有意向退保</Option>
            <Option value="10">准备续保</Option>
            <Option value="13">跟进完成</Option>
            <Option value="14">跟进终止</Option>
          </Select>
        </div>

        <div class="input-item">
          <span class="label">保单状态</span>
          <Select clearable v-model="searchParams.policyStatus">
            <Option
              :value="item.value"
              v-for="(item, index) in policyStatusList"
              :key="index"
              >{{ item.label }}</Option
            >
          </Select>
        </div>

        <div class="btn-item">
          <Button type="primary" @click="searchAjax()">搜索</Button>
          <Button type="primary" ghost @click="resetSearch()">重置</Button>
          <Button type="primary" ghost v-if="searchMore" @click="searchMore=false">收起<Icon type="ios-arrow-up" /></Button>
          <Button type="primary" ghost v-else @click="searchMore=true">展开<Icon type="ios-arrow-down" /></Button>
        </div>
      </div>

      <Tabs
        class="tabs"
        v-model="searchParams.tab"
        @on-click="toggleFirstTab"
        :animated="false"
      >
        <TabPane
          :label="item.label + '(' + item.num + ')'"
          :name="item.name"
          v-for="item in tabs"
          :key="item.name"
        ></TabPane>

        <div class="right">
          <Button
            type="primary"
            @click="$refs.importModal.open()"
            v-show="$units.pointAction('renewalManage_01_1')"
            >导入</Button
          >
          <Button
            v-show="$units.pointAction('renewalManage_01_2')"
            style=" border-color: #236dff;color: #236dff;"
            @click="exportExcel"
          >导出
          </Button>
          <Button style="border-color: #236dff; color: #236dff" @click="$refs.updateAbnormal.open()" v-show="$units.pointAction('renewalManage_01_3')">更新异常记录</Button>
        </div>
      </Tabs>

      <div class="tipBox clearfix">
        <div class="left clearfix" v-if="searchParams.tab ==1 || searchParams.tab == 4">
          <div>合计</div>
          <div>
            原单保费：
            <span class="other">{{ countObj.fee }}</span
            >元
          </div>

          <div>
            续保保费：
            <span class="other">{{ countObj.payFee }}</span
            >元
          </div>

          <div>
            服务费：
            <span class="other">{{ countObj.commissionPrice }}</span
            >元
          </div>
        </div>
      </div>

      <div class="table-box setTable">
        <loading :isShow="$root.$children[0].isShowLoading" />
        <Table :columns="columns" :data="tableDate">
          <template slot-scope="{ row }" slot="holderName">
            <div style="display: flex; align-items: center; white-space: nowrap; justify-content: center" v-if="row.holderName&&row.holderMobile">
              <span>{{row.holderName||'-'}}</span>/
              <span v-if="row.eyeShow">{{ row.holderMobile1 }}</span>
              <span v-else>{{ row.holderMobile }}</span>
              <div v-if="row.holderMobile">
                <i class="iconfont iconxianshi eye-icon eye" v-if="row.eyeShow" @click="openEye(row,'holderMobile1',2,'eyeShow')"></i>
                <i class="iconfont iconyincang eye-icon eye" v-else @click="openEye(row,'holderMobile1',2,'eyeShow')"></i>
              </div>
            </div>
            <div style="display: flex; align-items: center; white-space: nowrap; justify-content: center" v-else-if="!row.holderName&&row.holderMobile">
              <span v-if="row.eyeShow">{{ row.holderMobile1 }}</span>
              <span v-else>{{ row.holderMobile }}</span>
              <div v-if="row.holderMobile">
                <i class="iconfont iconxianshi eye-icon eye" v-if="row.eyeShow" @click="openEye(row,'holderMobile1',2,'eyeShow')"></i>
                <i class="iconfont iconyincang eye-icon eye" v-else @click="openEye(row,'holderMobile1',2,'eyeShow')"></i>
              </div>
            </div>
            <div style="display: flex; align-items: center; white-space: nowrap; justify-content: center" v-else-if="row.holderName&&!row.holderMobile">
              <span>{{row.holderName||'-'}}</span>
            </div>
          </template>
          <template slot-scope="{ row }" slot="productName">
            <div>{{ row.productName }}({{row.productCode}})</div>
          </template>
          <template slot-scope="{ row }" slot="policyNo">            
            <a class="policy-no" @click="toDetail(row)">{{ row.policyNo }}</a>
          </template>

          <div slot-scope="{ row }" slot="slotColumn" class="slot-column">
            <span v-if="row.day <= 5 || row.showRed" class="date-dian" :style="{background:'#ED0000'}"></span>          
            <span v-else-if="row.day > 5 && row.day <= 10" class="date-dian" :style="{background:'#FF750D'}"></span>          
            <span v-else-if="row.day > 11 && row.day <= 20" class="date-dian" :style="{background:'#FFB100'}"></span>          
            <span v-else-if="row.day > 20" class="date-dian" :style="{background:'#66DD2A'}"></span>          
            <span>{{row.dayText}}</span>
          </div>
          
          <template slot-scope="{ row }" slot="bar">
            <div class="detail" v-if="row.payState == 1">
              <div @click="toDetail(row)">详情</div>
              <div style="color: #3cb500" @click="$refs.renewalSuccess.open(row)" v-show="$units.pointAction('renewalManage_01_5')">续保成功</div>
              <div style="color: #ff4d00" @click="$refs.renewalFail.open(row)" v-show="$units.pointAction('renewalManage_01_6')">续保失败</div>
            </div>

            <div class="detail" v-else>
              <div @click="toDetail(row)">详情</div>
              <div @click="changeStatus(row)" v-show="$units.pointAction('renewalManage_01_7')">变更状态</div>
            </div>
          </template>
        </Table>
      </div>
      <div class="pageBox">
        <Page
          :total="total"
          :current="searchParams.pageNo"
          :page-size="searchParams.pageSize"
          show-total
          @on-change="pageChange"
          style="text-align: center"
        />
      </div>
    </div>
    <!-- 导入 -->
    <import-modal ref="importModal" :getInsureList='getInsureList'></import-modal>

    <!-- 更新异常 -->
    <update-abnormal ref="updateAbnormal" :getInsureList='getInsureList'></update-abnormal>

    <!-- 变更状态 -->
    <follow-up-modal ref="followUp" :id="rowId" :isList='true' :getInsureList='getInsureList'></follow-up-modal>

    <!-- 缴费成功 -->
    <renewal-success ref="renewalSuccess" :getInsureList='getInsureList'></renewal-success>

    <!-- 缴费失败 -->
    <renewal-fail ref="renewalFail" :getInsureList='getInsureList'></renewal-fail>
  </div>
</template>

<script>
import dayjs from 'dayjs';
import {pageTool,common} from "@/api/mixins";
import filters from "@/api/filter";
import selectTree from "@/components/system/selectTree3";
import importModal from "./components/importModal";
import updateAbnormal from "./components/updateAbnormal";
import { getOrganizationBase } from "@/api/httpList";
import followUpModal from './components/followUpModal';
import renewalSuccess from './components/renewalSuccess';
import renewalFail from './components/renewalFail';

import {
  allColumns,
  renewalProtectColumns,
  renewedColumns,
  otherColumns,
  columns5,
} from "./form/columns";

export default {
  mixins:[pageTool,common],
  components: {
    selectTree,
    importModal,
    updateAbnormal,
    followUpModal,
    renewalSuccess,
    renewalFail
  },

  data() {
    return {
      rowId:null,
      supplierList: [],// 供应商
      organizationList: [], //机构
      companyList: [], //保险公司
      sourceList:[],//产品来源
      tabs: [
        { label: "全部", name: "1", num: "" },
        { label: "待续保", name: "2", num: "" },
        { label: "续保失败", name: "3", num: "" },
        { label: "已续保", name: "4", num: "" },
        { label: "不可续保", name: "5", num: "" },
      ],
      renewalYearsList: [
        {
          label: "第一年",
          value: 1,
        },
        {
          label: "第二年",
          value: 2,
        },
        {
          label: "第三年",
          value: 3,
        },
        {
          label: "第四年",
          value: 4,
        },
        {
          label: "第五年",
          value: 5,
        },
      ],
      policyStatusList: [
        {
          label: "已承保",
          value: "1",
        },
        {
          label: "已退保",
          value: "-1",
        },
        {
          label: "已终止",
          value: "0",
        },
        {
          label: "已中止",
          value: "2",
        },
      ],
      serviceStateList: [
        {
          label: "全部",
          value: "",
        },
        {
          label: "已跟进",
          value: "2",
        },
        {
          label: "待跟进",
          value: "1",
        }
      ],
      tableDate: [], //表格数据
      productList: [], //产品列表
      columns: [], //表格列
      countObj: {},
      searchParams: {
        multiple: "1",
        policyNoSelect: "1",
        tab: "1",
        pageNo: 1,
        pageSize: 10,
      },
      total: 0,
      isSelectGroup:null
    };
  },

  mounted() {
    this.getColumns();
  },

  async created() {
    if (!this.$units.superviseShowVal()) {
      this.searchParams.supplierType = '1';
    }
    this.getProductList();
    this.queryOrganization();
    this.queryAllCompany();
    this.getSource();
  },

  activated() {
    this.getInsureList();
  },

  methods: {
    // 切换供应商类型
    changeSupplierType(value) {
      delete this.searchParams.supplierIds;
      this.supplierList = [];
      if (value == 1) {
        var url = '/buz/insuranceCompany/read/all';
      } else if (value == 2) {
        var url = '/buz/insuranceChannel/read/list';
      } else if (!value) {
        this.supplierList = [];
      }
      if (value) {
        this.$http({
          url,
          type: 'POST',
          data: {}
        }).then(res => {
          this.supplierList = res.data;
        });
      }
    },
    // 产品列表
    getProductList(){
      this.$http({
        url: `/buz/productBase/read/all`,
        type: "POST",
        data:{
        }
      }).then(res=>{
        this.productList = res.data;
      })
    },
    // 解密
    openEye(row,name,i,eyeShow) {
      if (!row[eyeShow]) {
        this.descrypt({
          query: row.id,
          operationFunction: 33,
          operationType: i,
        }, row, name).then(() => {
          this.$set(row, eyeShow, true);
        })
      } else {
        this.$set(row, eyeShow, false);
      }
    },

    // 机构
    async queryOrganization() {
      const { data } = await getOrganizationBase();
      this.organizationList = this.dealTree([data]);
    },

    // 选中机构/团队
    getSelectNodes(data) {
      // nodeType 1 机构  2团队
      if(data.nodeType==2){
        this.isSelectGroup = true;
      }else{
        this.isSelectGroup = false;
      }
    },

    dealTree(arr) {
      return arr.map((item) => ({
        ...item,
        expand: item.nodeType === 1 ? true : false,
        value: item,
        label: item.name,
        children:
          item.children && item.children.length > 0
            ? this.dealTree(item.children)
            : null,
      }));
    },

    // 获取保司
    async queryAllCompany() {
      this.$http({
        url: `/buz/insuranceCompany/read/list`,
        type: "POST",
        data:{companyType:"1"}
      }).then(res=>{
        this.companyList = res.data;
      })
    },

    // 获取保单来源
    getSource() {
      this.$http({
        url: "/buz/productBase/getProductSource",
        type: "get",
      }).then((res) => {
        this.sourceList = res.data;
      });
    },
    
    // 处理时间参数
    setRequestParam() {
      let obj = JSON.parse(JSON.stringify(this.searchParams));

      // 原保单生效日
      if (this.searchParams.multiple == 1 && this.searchParams.multipleDate && this.searchParams.multipleDate[0]) {
        obj.policyStartDateStart = filters.filterTime( this.searchParams.multipleDate[0], "YYYY-MM-DD");
        obj.policyStartDateEnd = filters.filterTime(this.searchParams.multipleDate[1], "YYYY-MM-DD");
      }else if(this.searchParams.multiple == 2 && this.searchParams.multipleDate && this.searchParams.multipleDate[0]) {
        // 最早续保日
        obj.earliestRenewalDateStart = filters.filterTime( this.searchParams.multipleDate[0], "YYYY-MM-DD");
        obj.earliestRenewalDateEnd = filters.filterTime(this.searchParams.multipleDate[1], "YYYY-MM-DD");
      }else if(this.searchParams.multiple == 3 && this.searchParams.multipleDate && this.searchParams.multipleDate[0]) {
        // 最晚续保日
        obj.latestRenewalDateStart = filters.filterTime( this.searchParams.multipleDate[0], "YYYY-MM-DD");
        obj.latestRenewalDateEnd = filters.filterTime(this.searchParams.multipleDate[1], "YYYY-MM-DD");
      }else if(this.searchParams.multiple == 4 && this.searchParams.multipleDate && this.searchParams.multipleDate[0]) {
        // 实际续保日
        obj.serverEndDateStart = filters.filterTime( this.searchParams.multipleDate[0], "YYYY-MM-DD");
        obj.serverEndDateEnd = filters.filterTime(this.searchParams.multipleDate[1], "YYYY-MM-DD");
      }

      // 原单到期日
      if (this.searchParams.expireDate && this.searchParams.expireDate[0]) {
        obj.policyEndDateStart = filters.filterTime( this.searchParams.expireDate[0], "YYYY-MM-DD");
        obj.policyEndDateEnd = filters.filterTime(this.searchParams.expireDate[1], "YYYY-MM-DD");
      }

      // 原保单单号
      if (this.searchParams.policyNoSelect == 1 && this.searchParams.policyNumber) {
        obj.policyNo = this.searchParams.policyNumber;
      }else if(this.searchParams.policyNoSelect == 2 && this.searchParams.policyNumber) {
        //续保单单号  
        obj.newPolicyNo = this.searchParams.policyNumber;
      }

      // 处理机构/团队参数key
      if(this.isSelectGroup && obj.orgId){
        obj.groupId = obj.orgId
        delete obj.orgId;
      }
      
      let { multiple, multipleDate, expireDate, policyNoSelect, policyNumber,  ...params } = obj;
      return params;
    },

    // 续保列表数据
    getInsureList() {      
      this.$root.$children[0].isShowLoading = true;
      this.$http({
        url: "/buz/policyShortRenewalRecord/read/list",
        type: "POST",
        data: this.setRequestParam(),
        apiPermissionCode:'renewalManage_01_0'
      })
        .then((res) => {
          this.getStatisticsData();
          this.$root.$children[0].isShowLoading = false;
          res.data.forEach(item=>{
            this.setDayText(item, res.timestamp);
          })
          this.tableDate = res.data;
          this.total = res.total;
        })
        .catch((e) => {
          console.log(e);
          this.$root.$children[0].isShowLoading = false;
        });
    },
    setDayText(row, timestamp){
      let date = '';
      let text = '';
      if(this.searchParams.tab == 5) {//不可续保
        date = row.policyEndDate;
        text = '保单到期日';
      }else{
        date = row.latestRenewalDate;
        text = '最晚续保日';
      }
      const now = dayjs(new Date(timestamp)).format('YYYY-MM-DD')+' 00:00:00';
      const dateOut = dayjs(new Date(date)).format('YYYY-MM-DD');
      if(now < date){
        row.day = dayjs(date).diff(now, 'day');
        text = `距${text}还剩 ${ row.day } 天`
      }else if(now == date){
        row.day = 0;
        text = `今天是${text}`
      }else{
        row.day = dayjs(now).diff(date, 'day');
        row.showRed = true;
        text = `${text}已过 ${ row.day } 天`
      }
      row.dayText = text+"（"+dateOut+"）";
    },

    // 统计
    getStatisticsData() {
      this.$http({
        url: "/buz/policyShortRenewalRecord/read/statistic",
        type: "POST",
        data: this.setRequestParam(),
      }).then((res) => {
        this.countObj = res.data.feeMap;
        console.log(this.countObj);
        this.tabs = this.tabs.map((item, index) => {
          return {
            ...item,
            num: res.data.tabMap[index + 1],
          };
        });
      });
    },

    // 查询
    searchAjax() {
      this.searchParams.pageNo = 1;
      this.getInsureList();
    },

    // 重置
    resetSearch() {
      this.searchParams = {
        multiple: "1",
        policyNoSelect: "1",
        tab: "1",
        pageNo: 1,
        pageSize: 10,
      };
      this.getInsureList();
    },

    //切换一级tab
    async toggleFirstTab(value) {
      this.getColumns();
      this.searchParams.pageNo = 1;
      this.searchParams.payWaitType ='';
      this.getInsureList();
    },
    // 获取表格列
    getColumns() {
      const value = this.searchParams.tab;
      let columns = [];
      if (value == 1) {
        columns = allColumns;
      } else if (value == 2) {
        columns = renewalProtectColumns;
      } else if (value == 4) {
        columns = renewedColumns;
      } else if (value == 3) {
        columns = otherColumns;
      } else if(value == 5) {
        columns = columns5;
      }
      // 没有供应商权限过滤
      if(!this.$units.superviseShowVal() || !this.$units.pointAction('renewalManage_01_10')){
        columns = columns.filter(item => item.key != 'supplierName');
      }
      this.columns = columns;
    },

    // 导出
    exportExcel() {
      this.$http({
        url: "/buz/policyShortRenewalRecord/export",
        type: "POST",
        forced: true,
        responseType: "blob",
        All: true,
        data: this.setRequestParam(),
        apiPermissionCode:'renewalManage_01_2'
      }).then(res=>{
        this.$units.daochu(res);
      })
    },

    // 详情
    toDetail(row) {
      this.$router.push({
        name: 'renewalManageDetail',
        query: { 
          row: JSON.stringify(row),
          status:this.searchParams.tab
        },
      })
    },  

    // 变更状态
    changeStatus(row) {
      this.rowId = row.id;
      this.$refs.followUp.open(row);
    },

    pageChange(pageNo) {
      this.searchParams.pageNo = pageNo;
      this.getInsureList();
    },
  },
};
</script>
<style lang="scss" scoped>
@import "./index.scss";

.btn-item {
  /deep/ .ivu-btn {
    font-size: 13px;
  }
}

/deep/ .input-item-select>.ivu-select-selection {
  border-right: none;
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
  border-top-right-radius: 0;
  height: 30px;
}

/deep/ .ivu-tabs-nav .ivu-tabs-tab-active {
  font-weight: bold;
}

/deep/ .ivu-table-cell>span {
  color: #515C6F;
}

/deep/ .ivu-modal-body {
  padding: 16px 30px;
}
/deep/ .formGroup {
  position: relative;
  &:after {
    position: absolute;
    bottom: -5px;
    width: 100%;
    height: 20px;
    content: "";
    filter: blur(5px);
    background: #fff;
  }
  padding: 0;
  .title {
    font-size: 16px;
    font-weight: bold;
    color: #3c464f;
  }
}
/deep/ .formGroup:after {
  display: none;
}
/deep/ .base {
  margin-top: 40px;
}
/deep/ .formGroup .title {
  font-size: 18px;
  color: #272933;
  margin-bottom: 0 !important;
  border-bottom: none !important;
}
/deep/ .ivu-form-item-content {
  color: #272933;
}
/deep/ .ivu-form-item {
  margin-bottom: 12px;
}
/deep/ .ivu-modal-body {
  padding: 16px 30px;
}
/deep/ .formGroup {
  height: unset !important;
  position: relative;
  &:after {
    position: absolute;
    bottom: -5px;
    width: 100%;
    height: 20px;
    content: "";
    filter: blur(5px);
    background: #fff;
  }
  padding: 0;
  .title {
    font-size: 16px;
    font-weight: bold;
    color: #3c464f;
  }
}
.slot-column {
  display: flex;
  justify-content: center;
  align-items: center;
}
.date-dian {
  width: 6px;
  height: 6px;
  margin-right: 6px;
  border-radius: 50%;
}
</style>